import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { features } from "src/utils/dataHomePage";

function FeaturesSection() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    <>
      <Typography
        variant="h4"
        textAlign="center"
        sx={{
          pt: { lg: 5, sm: 1 },
          pb: { lg: 5, sm: 1 },
          fontFamily: "Oswald, Arial",
          fontSize: { lg: "38px", xs: "25px" },
          color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
        }}
      >
        TURNKEY PLATFORM FOR YOUR BRAND.
      </Typography>

      {/* ----------------------------- */}

      <Grid pb={10} container spacing={0} justifyContent="center" alignItems="flex-start">
        {features.map((feature) => (
          <Grid item xs={8} sm={5} lg={2.5} pt={2} key={feature.id} display="flex" flexDirection="column" alignItems="center">
            <Box sx={{ pb: 2 }}>
              <img src={feature.img} alt={feature.textPrimary} style={{ width: "230px", height: "auto" }} />
            </Box>
            <Typography
              variant="h6"
              sx={{
                color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,

                pt: 2,
                pb: 2,
                width: "250px",
                fontSize: { lg: "25px", sm: "16px" },
                lineHeight: 1.2,
                textAlign: "center",
                whiteSpace: isDesktop ? "pre-line" : "normal",
              }}
            >
              {feature.id === 3
                ? isDesktop
                  ? "Custom Brand\nIntegrations"
                  : "Custom Brand Integrations"
                : feature.id === 4
                  ? isDesktop
                    ? "24 / 7 Product\nAvailability"
                    : "24 / 7 Product Availability"
                  : feature.textPrimary}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                fontFamily: "Roboto, Arial",
                fontWeight: "bold",
                fontSize: { lg: "16px", sm: "14px" },
                textAlign: "center",
                // pb: 2,
                lineHeight: 1.2,
                width: "200px",
              }}
            >
              {feature.textSecondary}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default FeaturesSection;
